export default __webpack_public_path__ + "static/share-replay-light-mode-803cc2054f6483d6d0d7cc99d56d4596.mp4";